import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import '../Styles/LandingPage.css';
const LocationSelector = ({ location, onChange, cities }) => (
  <div
    className="relative w-full max-w-lg flex items-center rounded-xl border border-gray-400"
    style={{ background: 'linear-gradient(to right, #6a11cb 50%, #ffffff 50%)',
      height:'3.2rem'
 
     }}
  >
    <div className="flex items-center justify-center px-3">
      <FaMapMarkerAlt className="text-gray-100" />
    </div>
    <select
      value={location}
      onChange={onChange}
      className="input-text-box w-full rounded-full"
      style={{height:'3.2rem'}}
      
    >
      <option value="">Select a location</option>
      {cities.map((city, index) => (
        <option key={index} value={city}>
          {city}
        </option>
      ))}
    </select>
  </div>
);

export default LocationSelector;
